import React, { Fragment } from 'react';
import { OneIdentityService } from '../service/oneIdentityService';
const { IconWarning, dlsBrightBlue, Anchor } = require('@americanexpress/dls-react');

const DisabledUserWarning: React.FC<{ t: any, warningType: 'disabled' | 'registryFailed' | 'invalidPhone' }> = ({ t, warningType }) => {
    const oneIdentityService = new OneIdentityService();
    return (
        <Fragment>
            <div className={`container margin-2-b margin-1-t pad-4 dls-white-bg text-align-center`}>
                <div className="margin-2-b">
                    <IconWarning
                        id="icon-hover"
                        size="lg"
                        titleId="success"
                        theme={dlsBrightBlue}
                        title="success"
                    />
                </div>

                {warningType === 'registryFailed' && (
                    <div>
                        <div className="body-1 margin-2-b">
                            <span>{t('warning_screen.oneApRegistryFailed1')}</span>
                            <span>
                                <Anchor href={oneIdentityService.oneIdentityPasswordResetURL()} inline={true} target="_blank" rel="noopener noreferrer">{t('warning_screen.oneApRegistryFailed2')}</Anchor>
                            </span>
                            <span>{t('warning_screen.oneApRegistryFailed3')}</span>
                            <div className='margin-2-t'>
                                <span>{t('warning_screen.oneApRegistryFailed4')}</span>
                                <span>
                                    <Anchor href={`mailto:${t('login.support_email')}`} inline={true} target="_blank" rel="noopener noreferrer">{t('login.support_email')}</Anchor>
                                </span>
                                <span>{t('warning_screen.oneApDisabledUser3')}</span>
                                <span>
                                    <Anchor href={`tel:${t('login.support_num')}`} inline={true} target="_blank" rel="noopener noreferrer">{t('login.support_num')}</Anchor>
                                </span>
                                <span>{t('warning_screen.oneApRegistryFailed5')}</span>
                            </div>
                        </div>
                    </div>
                )}

                {warningType === 'disabled' && (
                    <div>
                        <div className="heading-4 margin-2-b">{t('warning_screen.oneApDisabledUser1')}</div>
                        <div className="heading-4 margin-2-b">
                            <span>{t('warning_screen.oneApDisabledUser2')}</span>
                            <span>
                                <Anchor href={`mailto:${t('login.support_email')}`} inline={true}>{t('login.support_email')}</Anchor>
                            </span>
                            <span>{t('warning_screen.oneApDisabledUser3')}</span>
                            <span>
                                <Anchor href={`tel:${t('login.support_num')}`} inline={true}>{t('login.support_num')}</Anchor>
                            </span>
                            <span>{t('warning_screen.oneApDisabledUser4')}</span>
                        </div>
                    </div>
                )}

                {warningType === 'invalidPhone' && (
                    <div>
                        <div className="body-1 margin-2-b">
                            <span className='heading-4'>{t('warning_screen.oneIdentityInvalidPhone1')}</span>
                            <span className='heading-4'>
                                <Anchor href={oneIdentityService.oneIdentityManageProfileURL()} inline={true} target="_blank" rel="noopener noreferrer">{t('warning_screen.oneIdentityInvalidPhone2')}</Anchor>
                            </span>
                            <span className='heading-4'>{t('warning_screen.oneIdentityInvalidPhone3')}</span>
                            <div className='margin-2-t'>
                                <span>{t('warning_screen.oneApRegistryFailed4')}</span>
                                <span>
                                    <Anchor href={`mailto:${t('login.support_email')}`} inline={true} target="_blank" rel="noopener noreferrer">{t('login.support_email')}</Anchor>
                                </span>
                                <span>{t('warning_screen.oneApDisabledUser3')}</span>
                                <span>
                                    <Anchor href={`tel:${t('login.support_num')}`} inline={true} target="_blank" rel="noopener noreferrer">{t('login.support_num')}</Anchor>
                                </span>
                                <span>{t('warning_screen.oneApRegistryFailed5')}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default DisabledUserWarning;
